import { isImpersonating, getImpersonationToken } from './impersonationSession';

/**
 * Gets the access token from sessionStorage if impersonating, else localStorage
 */
export const getAccessToken = (): string | null | undefined => {
  if (isImpersonating()) {
    return getImpersonationToken();
  }
  const localToken = localStorage.getItem('clientAccessToken');
  return localToken;
};

/**
 * Gets the refresh token from sessionStorage if impersonating, else localStorage
 */
export const getRefreshToken = (): string | null | undefined => {
  if (isImpersonating()) {
    return sessionStorage.getItem('impersonation.refreshToken');
  }
  return localStorage.getItem('clientRefreshToken');
};

/**
 * Sets the authentication token in localStorage (ignored while impersonating)
 */
export const setToken = (token: string): void => {
  if (isImpersonating()) return;
  localStorage.setItem('clientAccessToken', token);
};

/**
 * Sets the refresh token in localStorage (ignored while impersonating)
 */
export const setRefreshToken = (token: string): void => {
  if (isImpersonating()) return;
  localStorage.setItem('clientRefreshToken', token);
};

/**
 * Clears the refresh token from storage
 */
export const clearRefreshToken = (): void => {
  if (isImpersonating()) {
    sessionStorage.removeItem('impersonation.refreshToken');
    return;
  }
  localStorage.removeItem('clientRefreshToken');
};

/**
 * Clears all authentication tokens from storage
 */
export const clearTokens = (): void => {
  if (isImpersonating()) {
    sessionStorage.removeItem('impersonation.accessToken');
    sessionStorage.removeItem('impersonation.refreshToken');
    return;
  }
  localStorage.clear();
};
